import { useSearchParams } from 'react-router-dom';

import {
  LANDING_FLOW_KIND_PARAM,
  LANDING_MEDIA_ID_PARAM,
  LANDING_TARGET_LANG_PARAM,
} from '@/shared/constants/routes/searchParams';
import { useExecuteOneTime } from '@/shared/hooks/useExecuteOneTime';

import { saveLandingFlow } from './landingFlowStorage';
import { type LandingFlowData, LandingFlowDataSchema, LandingFlowKind } from './types';

const parseLandingParams = (searchParams: URLSearchParams): LandingFlowData | null => {
  const kind = searchParams.get(LANDING_FLOW_KIND_PARAM);

  if (kind === LandingFlowKind.videoTranscript) {
    const parsedData = LandingFlowDataSchema.safeParse({
      kind,
      media_id: searchParams.get(LANDING_MEDIA_ID_PARAM),
      target_lang: searchParams.get(LANDING_TARGET_LANG_PARAM),
    });

    return parsedData.success ? parsedData.data : null;
  }

  return null;
};

export const useSaveLandingParams = (): void => {
  const [searchParams, setSearchParams] = useSearchParams();

  useExecuteOneTime(() => {
    const data = parseLandingParams(searchParams);

    if (data) {
      saveLandingFlow(data);

      // Strip landing params from URL
      const newParams = new URLSearchParams(searchParams);
      newParams.delete(LANDING_FLOW_KIND_PARAM);
      newParams.delete(LANDING_MEDIA_ID_PARAM);
      newParams.delete(LANDING_TARGET_LANG_PARAM);
      setSearchParams(newParams, { replace: true });
    }
  });
};
